import RCAUserWithAvatar from "../RCAUserWithAvatar";
import { useStyles } from "./RCAObservationItem.styles";
import { IRCAObservationItem } from "./RCAObservationItemInterfaces";
import useDateFormat from "hooks/useDateFormat";

const RCAObservationItem = ({ observation }: IRCAObservationItem) => {
    const classes = useStyles();
    const { formatDate } = useDateFormat();

    return (
        <section>
            <div className={classes.avatarWrapper}>
                <RCAUserWithAvatar
                    imageUrl={observation.user?.media?.media_url}
                    name={`${observation.user?.first_name} ${observation.user?.last_name}`}
                    isObservation
                    hideText
                />
                <div className={classes.nameAndDateWrapper}>
                    <span
                        className={classes.avatarName}
                    >{`${observation.user.first_name} ${observation.user.last_name}`}</span>
                    <span className={classes.avatarDate}>{formatDate(observation.created_at, true)}</span>
                </div>
            </div>
            <span className={classes.observationText}>{observation.description}</span>
        </section>
    );
};

export default RCAObservationItem;
